<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="onClickClose()"
            class="assign-formulation-stock-inventory-pop-up"
            title="UPDATE RM STOCK INVENTORY">
    <vx-card no-shadow cardBorder title="RM Batch Details">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
       
        <form id="update-rm-stock-popup" @submit.prevent="handleSubmit(onClickAssign)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="batch_no" name="batch_no" rules="required" v-slot="{ errors }">
                <small class="label">Batch Number</small>
                <vs-input readonly v-model="form.batch_no"   name="batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="company_product_code" name="company_product_code" rules="required" v-slot="{ errors }">
                <small class="label">ITS Product Code</small>
                <vs-input readonly :value="form.category + '-' + form.company_product_code"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Batch Number</small>
                <vs-input v-model="form.supplier_batch_no"   name="supplier_batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="manufacture_date" name="manufacture_date" rules="required" v-slot="{ errors }">
                <small class="label">Manufacturing Date</small>
                <flat-pickr
                  :config="{dateFormat: 'd/m/Y', maxDate: 'today'}"
                  class="hidden"
                  v-model="form.manufacture_date"
                  placeholder="Choose Manufacture Date"/>

                <flat-pickr :config="{dateFormat: 'd/m/Y', maxDate: 'today'}" class="w-full" v-model="form.manufacture_date"
                            placeholder="Choose Manufacture Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="expiration_date" name="expiration_date" rules="required" v-slot="{ errors }">
                <small class="label">ITS Expiry Date</small>
                <flat-pickr
                  :config="{dateFormat: 'd/m/Y'}"
                  class="hidden"
                  v-model="form.expiration_date"
                  placeholder="Choose Expiration Date"/>

                <flat-pickr :config="{dateFormat: 'd/m/Y'}" class="w-full" v-model="form.expiration_date"
                            placeholder="Choose Expiration Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="total_quantity" name="total_quantity" rules="required|number" v-slot="{ errors }">
                <small class="label">Original Order Item Quantity (Kg)</small>
                <vs-input disabled v-model="form.total_quantity"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="available_quantity" name="available_quantity" :rules="`required|number|max_number:${available_qty}`" v-slot="{ errors }">
                <small class="label">Available Quantity (Kg)</small>
                <vs-input v-model="form.available_quantity" name="available_quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <vs-alert v-if="is_reducing" active="true" class="w-full h-auto mb-2" color="warning" icon-pack="feather" icon="icon-info">
            You are reducing stock level by {{ Number(diff_qty).toFixed(4) }}KG.
          </vs-alert>
          <vs-alert v-if="!is_reducing && diff_qty > 0" active="true" class="w-full h-auto mb-4" color="danger" icon-pack="feather" icon="icon-info">
            You cannot increase the qty of this batch. If you wish to add stock greater than the original PO quantity, you must adjust the PO first 
            <a @click.stop="onClickOrder" class="cursor-pointer">Open PO</a>
          </vs-alert>
          
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="waste_status" name="waste_status" rules="required" v-slot="{ errors }">
                <small class="label">Status</small>
                <v-select  :clearable="true" name="waste_status" placeholder="" v-model="form.waste_status" :options="reasons" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <small class="text-danger">{{errors[0]}}</small>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.waste_status !== 'On Hold'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="reason_for_change" name="reason_for_change" :rules="form.waste_status === 'Other' ? 'required' : ''" v-slot="{ errors }">
                <small class="label">Reason for change</small>
                <vs-input v-model="form.reason_for_change" name="reason_for_change" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <vs-alert v-if="diff_qty !== 0 && !['Assigned to NPD', 'Sample to QC'].includes(form.waste_status) && !!form.waste_status && is_reducing" active="true" class="w-full h-auto" color="danger" icon-pack="feather" icon="icon-info">
            The adjusted stock {{ Number(diff_qty).toFixed(4) }}KG will be added to {{ form.waste_status !== 'On Hold' ? 'waste management for disposal' : 'on hold' }}
          </vs-alert>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="form.status === 'On Hold' || (!is_reducing && diff_qty > 0)" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>

    <!-- <vx-card noShadow cardBorder class="mt-8" title="Batch Opened / Started Status">
      <div class="vx-row">
        <div class="vx-col md:w-full w-full flex items-center justify-between">
          <div>
            <span class="font-semibold text-sm block">Opened / Started Status</span>
            <small class="text-muted">Flag this batch as opened/started so FIFO prioritizes using it up first.</small>
            <small v-if="isBatchOpenedToggleDisabled" class="text-danger block mt-1">
              Opened status can only be changed for in-stock batches with available quantity.
            </small>
          </div>
          <div class="flex items-center">
            <vs-chip :color="form.is_opened ? 'warning' : 'dark'" class="mr-3">
              {{ form.is_opened ? 'Opened / Started' : 'Unopened' }}
            </vs-chip>
            <vs-switch
              :disabled="isBatchOpenedToggleDisabled"
              :value="!!form.is_opened"
              @input="onToggleOpenedStatus"
              icon-pack="feather"
              vs-icon-on="icon-check-circle"
              vs-icon-off="icon-slash"
              class="w-16"
            />
          </div>
        </div>
      </div>
    </vx-card> -->

    <vx-card noShadow cardBorder class="mt-8" title="Shelf Location Details">
      <ValidationObserver ref="shelf_location_form" v-slot="{ handleSubmit }">
        <form id="update-rm-stock-popup" @submit.prevent="handleSubmit(onClickAssign)" autocomplete="off">
          <div class="vx-row mb-4">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="shelf_location_r" name="shelf_location_r" rules="required" v-slot="{ errors }">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>R</span>
                      </div>
                    </template>
                    <v-select v-model="form.shelf_location_r" style="border-radius: 0; z-index: 9" :options="shelf_location_r_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </vx-input-group>
                  <small class="text-danger">{{errors[0]}}</small>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="shelf_location_s" name="shelf_location_s" rules="required" v-slot="{ errors }">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>S</span>
                      </div>
                    </template>
                    <v-select v-model="form.shelf_location_s" style="border-radius: 0; z-index: 9" :options="shelf_location_s_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </vx-input-group>
                  <small class="text-danger">{{errors[0]}}</small>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="shelf_location_l" name="shelf_location_l" rules="required" v-slot="{ errors }">
                  <vx-input-group>
                    <template slot="prepend">
                      <div class="prepend-text bg-primary">
                        <span>L</span>
                      </div>
                    </template>
                    <v-select v-model="form.shelf_location_l" style="border-radius: 0; z-index: 9" :options="shelf_location_l_options" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  </vx-input-group>
                  <small class="text-danger">{{errors[0]}}</small>
                </ValidationProvider>
              </div>
          </div> 
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="form.status === 'On Hold' || (!is_reducing && diff_qty > 0)" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>    
    </vx-card>
    <!-- <vx-card noShadow cardBorder class="mt-8" title="Taste Panel">
      <div>
            <TastePanelList :batchId="id" batchType="Raw Material Inventory"/>
          </div>
    </vx-card> -->
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const SettingsRepository = RepositoryFactory.get('settings');
  const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'
  import {
    mapActions, mapGetters
  } from 'vuex'
  import TastePanelList from '@/components/TastePanel/TastePanelList.vue';

  function initialState() {
    return {
      open: false,
      id: '',
      shelf_location_r_options: [],
      shelf_location_s_options: [],
      shelf_location_l_options: [],
      reasons: ['Assigned to NPD', 'Product Loss - Human error', 'Product Loss - Multiple weight out', 'Sample to QC', 'Product Expired', 'Inventory Difference', 'On Hold', 'Stock Check Adjustments','QC Rejected', 'Other'],
      form: {
        manufacture_date: '',
        expiration_date: '',
        supplier_batch_no: '',
        batch_no: '',
        company_product_code: '',
        category: '',
        reason_for_change: '',
        is_opened: false,
      },
      other_reason: '',
      available_qty: ''
    }
  }

  export default {
    name: 'AssignFormulationStockPopUp',
    mixins: [SuccessMessage, ErrorMessages],
    data() {
      return initialState()
    },
    methods: {
      async onToggleOpenedStatus() {
        if (this.isBatchOpenedToggleDisabled) {
          this.showWarningMessage('Opened status can only be changed for in-stock batches with available quantity.')
          return
        }
        await this.$vs.loading({
          container: '#update-rm-stock-popup',
          scale: 0.45
        })
        try {
          const newStatus = !this.form.is_opened
          await ManufacturingRepository.toggleRawMaterialStockOpened(this.id, { is_opened: newStatus })
          this.$set(this.form, 'is_opened', newStatus)
          this.showSuccessMessage(`Batch open status changed to ${newStatus ? 'Opened/Started' : 'Unopened'}`)
          this.$emit('refreshData')
        } catch (e) {
          this.convertAndNotifyError(e)
        } finally {
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
        }
      },
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.id = id;
          this.open = true;
          await this.fetchRmStockDetails()
          await this.generateShelfLocationOptions()
        } catch (error) {

        }
      },
      async onClickAssign() {
        const vue = this
        await this.$vs.loading({
          container: '#update-rm-stock-popup',
          scale: 0.45
        })
        try {
          const payload = {
            total_quantity: this.form.total_quantity,
            available_quantity: this.form.available_quantity,
            shelf_location_r: this.form.shelf_location_r,
            shelf_location_s: this.form.shelf_location_s,
            shelf_location_l: this.form.shelf_location_l,
            manufacture_date: this.form.manufacture_date,
            expiration_date: this.form.expiration_date,
            waste_status: this.form.waste_status  ? this.form.waste_status : 'Other' ,
            reason_for_change: !this.form.waste_status ? 'Added warehouse location' : (this.form.reason_for_change || ''),
            supplier_batch_no: this.form.supplier_batch_no,
          }
          await ManufacturingRepository.updateRawMaterialStock(this.id, payload)
          this.showSuccessMessage('Raw Material Stock Inventory Updated!')
          this.open = false
          vue.$emit('refreshData')
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
        } catch (e) {
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
      },
      async fetchRmStockDetails() {
        await this.$vs.loading({
          container: '#update-rm-stock-popup',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getRawMaterialStockDetails(this.id)
          this.form = data.data
          this.available_qty = this.form.available_quantity

          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
        } catch (e) {
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
          this.showErrorMessage(e.response.data.data.errors)
        }
      },
      async generateShelfLocationOptions() {

        const settings = (await SettingsRepository.getTheItem('shelf_location_r_from,shelf_location_r_to,shelf_location_s_from,shelf_location_s_to,shelf_location_l_from,shelf_location_l_to')).data.data

        let r_from = settings.shelf_location_r_from
        let r_to = settings.shelf_location_r_to

        let s_from = settings.shelf_location_s_from
        let s_to = settings.shelf_location_s_to

        let l_from = settings.shelf_location_l_from
        let l_to = settings.shelf_location_l_to

        let start_r = Number(r_from)
        const end_r = Number(r_to)

        let start_s = Number(s_from)
        const end_s = Number(s_to)

        let start_l = Number(l_from)
        const end_l = Number(l_to)

        while (start_r <= end_r) {
          this.shelf_location_r_options.push(start_r.toString());
          start_r++;
        }

        while (start_s <= end_s) {
          this.shelf_location_s_options.push(start_s.toString());
          start_s++;
        }

        while (start_l <= end_l) {
          this.shelf_location_l_options.push(start_l.toString());
          start_l++;
        }

      },
      onClickClose() {
        this.$emit('refreshData')
        this.open = false
      },
      onClickSaveShelfLocation() {
        try {
          
        } catch (error) {
          
        }
      },
      onClickOrder() {
        let route = this.$router.resolve({path: `/pages/raw-materials/orders/${this.form.raw_material_order_id}`});
        window.open(route.href, '_blank');
      }
    },
    components: {
      flatPickr,
      'v-select': vSelect,
      TastePanelList
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      diff_qty: function () {
        let diff = Number(this.form.available_quantity) - Number(this.available_qty)
        return Math.abs(diff)
      },
      is_reducing: function () {
        let diff = Number(this.form.available_quantity) - Number(this.available_qty)
        return diff < 0
      },
      isBatchOpenedToggleDisabled: function () {
        const isStatusOk = this.form.status === 'In_Stock' || this.form.status === 'In-Stock'
        const isQtyOk = Number(this.form.available_quantity) > 0
        return !isStatusOk || !isQtyOk
      },
    },
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-pop-up >>> .vs-popup {
    min-height: 60% !important;
    min-width: 40% !important;
  }

</style>
